import React from "react";
import ReactDOM from "react-dom/client";
import AiConsultancy from "./ai-consultancy";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AiConsultancy />
  </React.StrictMode>,
);
